import { render, staticRenderFns } from "./emptySwitchActivityList.vue?vue&type=template&id=81f46f56&scoped=true"
import script from "./emptySwitchActivityList.vue?vue&type=script&lang=js"
export * from "./emptySwitchActivityList.vue?vue&type=script&lang=js"
import style0 from "./emptySwitchActivityList.vue?vue&type=style&index=0&id=81f46f56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f46f56",
  null
  
)

export default component.exports